import React, {Component} from "react";
import PropTypes from 'prop-types'
import './index.css'

class Label extends Component {
    static defaultProps = {
        size: 'medium',
        className: null,
        align: 'right',
        style: {}
    };

    static propTypes = {
        size: PropTypes.oneOf(['small', 'medium', 'large']),
        className: PropTypes.string,
        align: PropTypes.oneOf(['right', 'center', 'left']),
        style:PropTypes.object
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.props.children!== nextProps.children;
    }

    render() {
        const {props} = this;

        return (<label className={`Label ${props.size} ${props.className} ${props.align}`} style={props.style}>{props.children}</label>);
    }
}

export default Label